"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { INotificationAllDrops } from "@/types/feed.types";
import { getTimeAgoShort, numberWithCommas } from "@/helpers/Helpers";
import { ActiveDropState } from "@/types/dropInteractionTypes";
import Drop, { DropInteractionParams, DropLocation } from "@/components/waves/drops/Drop";
import { DropSize, ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useRouter } from "next/navigation";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { getNotificationVoteColor } from "../drop-reacted/NotificationDropReacted";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { getWaveRoute } from "@/helpers/navigation.helpers";
export default function NotificationAllDrops(t0) {
  const $ = _c(41);
  const {
    notification,
    activeDrop,
    onReply,
    onQuote,
    onDropContentClick
  } = t0;
  const router = useRouter();
  const {
    isApp
  } = useDeviceInfo();
  const baseWave = notification.related_drops[0].wave as any;
  const isDirectMessage = baseWave?.chat?.scope?.group?.is_direct_message ?? false;
  let t1;
  if ($[0] !== isApp || $[1] !== isDirectMessage || $[2] !== notification.related_drops[0].wave.id || $[3] !== router) {
    t1 = serialNo => {
      router.push(getWaveRoute({
        waveId: notification.related_drops[0].wave.id,
        serialNo,
        isDirectMessage,
        isApp
      }));
    };
    $[0] = isApp;
    $[1] = isDirectMessage;
    $[2] = notification.related_drops[0].wave.id;
    $[3] = router;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onReplyClick = t1;
  let t2;
  if ($[5] !== isApp || $[6] !== isDirectMessage || $[7] !== router) {
    t2 = quote => {
      const quoteWave = quote.wave as any;
      const quoteIsDm = quoteWave?.chat?.scope?.group?.is_direct_message ?? isDirectMessage;
      router.push(getWaveRoute({
        waveId: quote.wave.id,
        serialNo: quote.serial_no,
        isDirectMessage: quoteIsDm,
        isApp
      }));
    };
    $[5] = isApp;
    $[6] = isDirectMessage;
    $[7] = router;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const onQuoteClick = t2;
  let t3;
  if ($[9] !== notification.additional_context.vote || $[10] !== notification.related_drops[0].author || $[11] !== notification.related_identity.handle) {
    t3 = () => {
      const userLink = <Link href={`/${notification.related_identity.handle}`} className="tw-no-underline tw-font-semibold">{notification.related_identity.handle}</Link>;
      if (typeof notification.additional_context.vote === "number") {
        const isReset = notification.additional_context.vote === 0;
        const voteText = isReset ? "reset rating to 0" : <>rated{" "}<span className={`${getNotificationVoteColor(notification.additional_context.vote)} tw-pl-1 tw-font-medium`}>{notification.additional_context.vote > 0 && "+"}{numberWithCommas(notification.additional_context.vote)}</span></>;
        return <>{userLink} {voteText}</>;
      }
      return <><span className="tw-text-iron-400"> new post from </span><Link href={`/${notification.related_drops[0].author.handle}`} className="tw-no-underline tw-font-semibold">{notification.related_drops[0].author.handle}</Link></>;
    };
    $[9] = notification.additional_context.vote;
    $[10] = notification.related_drops[0].author;
    $[11] = notification.related_identity.handle;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const getContent = t3;
  let t4;
  if ($[13] !== notification.related_identity.pfp) {
    t4 = <div className="tw-h-7 tw-w-7">{notification.related_identity.pfp ? <img src={getScaledImageUri(notification.related_identity.pfp, ImageScale.W_AUTO_H_50)} alt="#" className="tw-flex-shrink-0 tw-object-contain tw-h-full tw-w-full tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-iron-700" /> : <div className="tw-flex-shrink-0 tw-object-contain tw-h-full tw-w-full tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-iron-700" />}</div>;
    $[13] = notification.related_identity.pfp;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== getContent) {
    t5 = getContent();
    $[15] = getContent;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="tw-font-bold tw-mr-1 tw-text-xs tw-text-iron-400">•</span>;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== notification.created_at) {
    t7 = getTimeAgoShort(notification.created_at);
    $[18] = notification.created_at;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t7) {
    t8 = <span className="tw-text-sm tw-text-iron-300 tw-font-normal tw-whitespace-nowrap">{t6}{" "}{t7}</span>;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t5 || $[23] !== t8) {
    t9 = <span className="tw-text-sm tw-font-normal tw-text-iron-50">{t5}{" "}{t8}</span>;
    $[22] = t5;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t4 || $[26] !== t9) {
    t10 = <div className="tw-flex tw-gap-x-2 tw-items-center">{t4}{t9}</div>;
    $[25] = t4;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== notification.related_drops[0]) {
    t11 = {
      type: DropSize.FULL,
      ...notification.related_drops[0],
      stableKey: "",
      stableHash: ""
    };
    $[28] = notification.related_drops[0];
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== activeDrop || $[31] !== onDropContentClick || $[32] !== onQuote || $[33] !== onQuoteClick || $[34] !== onReply || $[35] !== onReplyClick || $[36] !== t11) {
    t12 = <Drop drop={t11} previousDrop={null} nextDrop={null} showWaveInfo={true} showReplyAndQuote={true} activeDrop={activeDrop} location={DropLocation.MY_STREAM} dropViewDropId={null} onReply={onReply} onQuote={onQuote} onReplyClick={onReplyClick} onQuoteClick={onQuoteClick} onDropContentClick={onDropContentClick} />;
    $[30] = activeDrop;
    $[31] = onDropContentClick;
    $[32] = onQuote;
    $[33] = onQuoteClick;
    $[34] = onReply;
    $[35] = onReplyClick;
    $[36] = t11;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== t10 || $[39] !== t12) {
    t13 = <div className="tw-w-full tw-flex tw-gap-x-3"><div className="tw-w-full tw-flex tw-flex-col tw-space-y-2">{t10}{t12}</div></div>;
    $[38] = t10;
    $[39] = t12;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  return t13;
}